module.exports = [{
      plugin: require('../../../home/bright/Documents/Projects/brightbytes.dev/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":740,"linkImagesToOriginal":false,"wrapperStyle":"margin: 1.8em auto;"},
    },{
      plugin: require('../../../home/bright/Documents/Projects/brightbytes.dev/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"BrightBytes.dev","short_name":"BrightBytes","start_url":"/","display":"minimal-ui","background_color":"#faf9f6","theme_color":"#0f766e","icon":"static/brand-mark.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"6a21739b0bf4502e73d81fac2710f17a"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../home/bright/Documents/Projects/brightbytes.dev/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
